export default __webpack_public_path__ + "static/media/blur 1.06cfe206.jpg";